import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import { Lead, LeadOverrideStore, LeadScreenStore } from "../../stores/LeadStore"
import ListItemIcon from '@mui/material/ListItemIcon';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useState } from "react";
import Link from "@mui/material/Link";
import DateRangeIcon from '@mui/icons-material/DateRange';
import { LeadGridItem } from "../../types/Lead";
import { client } from "../../utils/axios-client";
import { useQueryClient } from "@tanstack/react-query";

type Props = {
    row: LeadGridItem

}


const OverrideMenu = ({ row }: Props) => {
    const [anchorEl, setAnchorEl] = useState<Element | null>(null);
    const queryClient = useQueryClient();

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = async (actionType: string, lead: LeadGridItem) => {
        const leadData = await queryClient.fetchQuery<Lead>({
            queryKey: ['leads-list-loaded-lead', lead.id],
            queryFn: () => {
                return client.get(`/api/leads/get/${lead.id}`).then((res) => res.data)
            },
        });

        LeadScreenStore.update(s => { s.selectedLead = leadData });
        switch (actionType) {
            case "ACTIVITY":
                LeadOverrideStore.update(s => { s.changeActivityMode = true })
                LeadOverrideStore.update(s => { s.changeCadenceMode = false })
                LeadOverrideStore.update(s => { s.changeSprintMode = false })
                LeadOverrideStore.update(s => { s.changeOwnerMode = false })
                LeadOverrideStore.update(s => { s.changeDateMode = false })
                break;
            case "CADENCE":
                LeadOverrideStore.update(s => { s.changeActivityMode = false })
                LeadOverrideStore.update(s => { s.changeCadenceMode = true })
                LeadOverrideStore.update(s => { s.changeSprintMode = false })
                LeadOverrideStore.update(s => { s.changeOwnerMode = false })
                LeadOverrideStore.update(s => { s.changeDateMode = false })
                break;
            case "SPRINT":
                LeadOverrideStore.update(s => { s.changeActivityMode = false })
                LeadOverrideStore.update(s => { s.changeCadenceMode = false })
                LeadOverrideStore.update(s => { s.changeSprintMode = true })
                LeadOverrideStore.update(s => { s.changeOwnerMode = false })
                LeadOverrideStore.update(s => { s.changeDateMode = false })
                break;
            case "OWNER":
                LeadOverrideStore.update(s => { s.changeActivityMode = false })
                LeadOverrideStore.update(s => { s.changeCadenceMode = false })
                LeadOverrideStore.update(s => { s.changeSprintMode = false })
                LeadOverrideStore.update(s => { s.changeOwnerMode = true })
                LeadOverrideStore.update(s => { s.changeDateMode = false })
                break;
            case "DATE":
                LeadOverrideStore.update(s => { s.changeActivityMode = false })
                LeadOverrideStore.update(s => { s.changeCadenceMode = false })
                LeadOverrideStore.update(s => { s.changeSprintMode = false })
                LeadOverrideStore.update(s => { s.changeOwnerMode = false })
                LeadOverrideStore.update(s => { s.changeDateMode = true })
                break;
            default:

        }
        setAnchorEl(null);
    };

    return (
        <>
        <Link
            sx={{ color: 'text.primary', textDecoration: 'none' }}
            underline="hover"
            component="button"
            variant="caption"
            onClick={handleClick}
            aria-controls={open ? 'override-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
        >
            Override
        </Link>  
        <Menu
            anchorEl={anchorEl}
            id="override-menu"
            open={open}
            onClose={() => handleClose("", row)}
            //onClick={() => handleClose("", row)}
            PaperProps={{
                elevation: 0,
                sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <MenuItem onClick={() => handleClose("ACTIVITY", row)}>
                <ListItemIcon>
                    <ChangeCircleIcon />
                </ListItemIcon>
                Change Activity
            </MenuItem>
            <MenuItem onClick={() => handleClose("CADENCE", row)}>
                <ListItemIcon>
                    <DisplaySettingsIcon />
                </ListItemIcon>
                Change Cadence
            </MenuItem>
            <MenuItem onClick={() => handleClose("SPRINT", row)}>
                <ListItemIcon>
                    <ManageHistoryIcon />
                </ListItemIcon>
                Change Sprint
            </MenuItem>
            <MenuItem onClick={() => handleClose("OWNER", row)}>
                <ListItemIcon>
                    <ManageAccountsIcon />
                </ListItemIcon>
                Change Owner
                </MenuItem>
            <MenuItem onClick={() => handleClose("DATE", row)}>
                <ListItemIcon>
                        <DateRangeIcon />
                </ListItemIcon>
                Change Activity Date
            </MenuItem>
            </Menu>
        </>
        )

}
export default OverrideMenu